import { Action } from '@ngrx/store';

export enum ToolsActionType {
  SEARCHING = '[TOOLS] searching TOOLS',
}

export class AddToolsAction implements Action {

  readonly type = ToolsActionType.SEARCHING;
  constructor(public payload: any) { }

}

export type ToolsAction = AddToolsAction;